/*
File for the endpoint identification process code
*/
import axios from 'axios'
import { projectName } from './router/routes.js'

function isCorrectServerInfoForThisProject (serverinfo) {
  if (typeof (serverinfo.Server) === 'undefined') {
    return false
  }
  if (typeof (serverinfo.Server.APIAPP_PROJECT_NAME) === 'undefined') {
    return false
  }
  if (serverinfo.Server.APIAPP_PROJECT_NAME !== projectName) {
    return false
  }
  return true
}

function isValidJSON (data) {
  if (typeof (data) === 'object') {
    return true
  }
  try {
    JSON.parse(data)
    return true
  } catch (e) {
    return false
  }
}

function startEndpointIdentificationProcess ({ endpointName, callback, rjmStateChange }) {
  if (typeof (endpointName) !== 'string') {
    console.log('ERROR startEndpointIdentificationProcess wrong type of endpointName supplied', endpointName, typeof (endpointName))
    throw new Error('ERROR startEndpointIdentificationProcess wrong type of endpointName supplied')
  }
  const initialEndpointInfo = rjmStateChange.getFromState('getEndpointInfo')(endpointName)
  if (typeof (initialEndpointInfo) === 'undefined') {
    console.log('ERROR - no endpoint info for endpoint name=', endpointName)
  }
  if (initialEndpointInfo.endpointIdentificationProcessState !== 0) return
  rjmStateChange.executeAction('setEndpointIdentificationProcessState', { endpointName, newState: 1 })

  const callbackInternal = {
    ok: function ({ serverinfoResponse, endpointName, sucessfulapiprefix }) {
      // // console.log('Success API response recieved')
      // // console.log('startEndpointIdentificationprocess Success', serverinfoResponse, sucessfulapiprefix)
      if (!isCorrectServerInfoForThisProject(serverinfoResponse.data)) {
        console.log('EndpointIdentificationprocess FAILED for', endpointName, ' this is not the server info for this project')
        rjmStateChange.executeAction('setEndpointIdentificationProcessState', { endpointName, newState: 0 })
        callback.error(serverinfoResponse)
        return
      }
      if (!isValidJSON(serverinfoResponse.data)) {
        console.log('EndpointIdentificationprocess FAILED invalid json for', endpointName, ' with response ', serverinfoResponse)
        rjmStateChange.executeAction('setEndpointIdentificationProcessState', { endpointName, newState: 0 })
        callback.error(serverinfoResponse)
        return
      }
      if (typeof (serverinfoResponse.data.Server) === 'undefined') {
        console.log('EndpointIdentificationprocess FAILED server not found', endpointName, ' with response ', serverinfoResponse)
        rjmStateChange.executeAction('setEndpointIdentificationProcessState', { endpointName, newState: 0 })
        callback.error(serverinfoResponse)
        return
      }
      if (typeof (serverinfoResponse.data.Server.Version) === 'undefined') {
        console.log('EndpointIdentificationprocess FAILED server.version not found', endpointName, ' with response ', serverinfoResponse)
        rjmStateChange.executeAction('setEndpointIdentificationProcessState', { endpointName, newState: 0 })
        callback.error(serverinfoResponse)
        return
      }
      rjmStateChange.executeAction('finishedEndpointIdentificationProcess', {
        endpointName,
        sucessfulapiprefix,
        serverInfo: serverinfoResponse.data
      })
      const endpointInfo = rjmStateChange.getFromState('getEndpointInfo')(endpointName)
      if (typeof (endpointInfo.finishEndPointIdentificationHook) !== 'undefined') {
        const param = {
          serverInfo: endpointInfo.serverInfo,
          apiPrefix: endpointInfo.apiPrefix
        }
        endpointInfo.finishEndPointIdentificationHook(param)
      }
      callback.ok({ serverinfoResponse, endpointName, sucessfulapiprefix })
    },
    error: function (response) {
      // Need to watch for infinite loop
      console.log('EndpointIdentificationprocess FAILED for', endpointName, ' with response ', response)
      rjmStateChange.executeAction('setEndpointIdentificationProcessState', { endpointName, newState: 0 })
      callback.error(response)
    }
  }
  tryToReadServerInfoFromAllThesePossibleAPIPrefixes({
    possibleApiPrefixes: initialEndpointInfo.apiPrefixIdentificationProcessConfig.possibleApiPrefixes,
    callback: callbackInternal,
    endpointName
  })
}

function getUrlToCall (prefixRecord, apiPath, orveridePublicPrivatePart) {
  // apitype can be either 'public' or 'private' and it's the kong endpoint part of the url
  let apiTypeToUse = prefixRecord.apitype
  if (typeof (orveridePublicPrivatePart) !== 'undefined') {
    apiTypeToUse = orveridePublicPrivatePart
  }
  if (prefixRecord.connectingthroughnginx) {
    return prefixRecord.prefix + '/' + apiTypeToUse + '/api' + apiPath
  }
  return prefixRecord.prefix + '/api/' + apiTypeToUse + apiPath
}

function tryToReadServerInfoFromAllThesePossibleAPIPrefixes ({ possibleApiPrefixes, callback, endpointName }) {
  if (possibleApiPrefixes.length === 0) {
    callback.error('Fail')
    return
  }
  const prefixToTry = possibleApiPrefixes.shift()

  const config = {
    method: 'GET',
    url: getUrlToCall(prefixToTry, '/info/serverinfo')
  }
  console.log('Trying to reach API at ' + config.url)
  axios(config).then(
    (response) => {
      console.log('tryToReadServerInfoFromAllThesePossibleAPIPrefixes - SUCCESS! - reached api at ' + config.url)
      if (!isCorrectServerInfoForThisProject(response.data)) {
        console.log('FAILED - reached api at ' + config.url + ' - but this server info is not for this project')
        console.log(' possibleApiPrefixes remaining', possibleApiPrefixes)
        tryToReadServerInfoFromAllThesePossibleAPIPrefixes({ possibleApiPrefixes, callback, endpointName })
        return
      }
      callback.ok({
        serverinfoResponse: response,
        endpointName,
        sucessfulapiprefix: prefixToTry
      })
    },
    (response) => {
      console.log('tryToReadServerInfoFromAllThesePossibleAPIPrefixes - FAILED')
      tryToReadServerInfoFromAllThesePossibleAPIPrefixes({ possibleApiPrefixes, callback, endpointName })
    }
  )
}

export default {
  startEndpointIdentificationProcess
}
